export default __webpack_public_path__ + "images/b9520856aaa6590b562516f1f7f9a661.svg";